import React, { useState } from 'react';
import { Modal, Button,Collapse,Row,Col,Descriptions,Typography,Tabs,Divider,Alert} from 'antd';
import Spreadsheet from 'react-spreadsheet';
import styled from 'styled-components';
import {useParentState} from 'utils';
import { v4 as uuidv4 } from 'uuid';
import SchemaForm from './schemaForm';
import Excel from './excel';
import Language from './language';


const MyModal =styled(Modal)`
  .ant-modal-body {
  display: flex;
  // flex-direction: column;
  // align-content: center;
  // align-items: center;
}
`;
const New = ({
  schema,
  parent,
  title="",
  data:initialData,
  isVisible:_isVisible=true,
  setVisible:_setVisible,
  onFinish,
  columns
  }) => {
   const [isVisible, setVisible] = useParentState(_isVisible,_setVisible);
  
  const handleOk = (data) => {
    setVisible(false);    
    
    onFinish && onFinish(data);    
  };

  const handleCancel = () => {
    setVisible(false);
  }; 
  
  const items = [
  {
    key: '1',
    label: <Language id="newlabel"/>,
    children: <>      
      <Alert showIcon  message=<Language id="newtitle"/> description=<Language id="newmessage"/> type="info" />
      <Divider />
      <SchemaForm schema={schema.items} parentData={parent} data={{
        id:uuidv4(),
        isSave:true,
        input:{
            marine:{zone:[],vessel:[]},
            road:{
              fuel:[],
              vehicles:[],
              highwayVehicles:[],
              custom:[ {              id:uuidv4(),
              name:"Average/Moyen",
              data:[
 {
   "id": "0",
   "age": 0,
   "number": 23655,
   "percentage": 3.6
 },
 {
   "id": "1",
   "age": 1,
   "number": 35541,
   "percentage": 6.7
 },
 {
   "id": "2",
   "age": 2,
   "number": 29319,
   "percentage": 6.7
 },
 {
   "id": "3",
   "age": 3,
   "number": 26627,
   "percentage": 18.8
 },
 {
   "id": "4",
   "age": 4,
   "number": 23115,
   "percentage": 11.5
 },
 {
   "id": "5",
   "age": 5,
   "number": 20070,
   "percentage": 10.0
 },
 {
   "id": "6",
   "age": 6,
   "number": 17436,
   "percentage": 6.9
 },
 {
   "id": "7",
   "age": 7,
   "number": 15142,
   "percentage": 5.2
 },
 {
   "id": "8",
   "age": 8,
   "number": 13142,
   "percentage": 3.0
 },
 {
   "id": "9",
   "age": 9,
   "number": 11383,
   "percentage": 4.8
 },
 {
   "id": "10",
   "age": 10,
   "number": 9837,
   "percentage": 6.4
 },
 {
   "id": "11",
   "age": 11,
   "number": 8777,
   "percentage": 4.2
 },
 {
   "id": "12",
   "age": 12,
   "number": 7192,
   "percentage": 3.5
 },
 {
   "id": "13",
   "age": 13,
   "number": 6109,
   "percentage": 2.0
 },
 {
   "id": "14",
   "age": 14,
   "number": 5076,
   "percentage": 1.6
 },
 {
   "id": "15",
   "age": 15,
   "number": 4343,
   "percentage": 1.6
 },
 {
   "id": "16",
   "age": 16,
   "number": 3600,
   "percentage": 1.0
 },
 {
   "id": "17",
   "age": 17,
   "number": 2990,
   "percentage": 0.6
 },
 {
   "id": "18",
   "age": 18,
   "number": 2562,
   "percentage": 0.3
 },
 {
   "id": "19",
   "age": 19,
   "number": 2214,
   "percentage": 0.2
 },
 {
   "id": "20",
   "age": 20,
   "number": 1919,
   "percentage": 0.3
 },
 {
   "id": "21",
   "age": 21,
   "number": 1668,
   "percentage": 0.2
 },
 {
   "id": "22",
   "age": 22,
   "number": 1451,
   "percentage": 0.3
 },
 {
   "id": "23",
   "age": 23,
   "number": 1266,
   "percentage": 0.1
 },
 {
   "id": "24",
   "age": 24,
   "number": 5567,
   "percentage": 0.1
 },
 {
   "id": "25",
   "age": 25,
   "number": 5567,
   "percentage": 0.1
 },
 {
   "id": "26",
   "age": 26,
   "number": 5567,
   "percentage": 0.0
 },
 {
   "id": "27",
   "age": 27,
   "number": 5567,
   "percentage": 0.0
 },
 {
   "id": "28",
   "age": 28,
   "number": 5567,
   "percentage": 0.0
 },
 {
   "id": "29",
   "age": 29,
   "number": 5567,
   "percentage": 0.0
 },
 {
   "id": ">30",
   "age": 30,
   "number": 5567,
   "percentage": 0.1
 }
]
              
              }            ]
            }
          }
          }
          } setData={handleOk} showSubmit={true}/>
      </>,
  },
  {
    key: '2',
    label: <Language id="importlabel"/>,
    children: <> 
      <Alert showIcon type="info"  message=<Language id="importtitle"/> description={<>
        <Typography.Text>
        <Language id="importmessage"/>
        </Typography.Text>
        <br />
        <Typography.Link href="https://peit-oiep.s3.amazonaws.com/public/template/OIEP-PEIT 2025 Questionnaire (locked 2025-05-14).xlsx">  <Language id="downloadexcel"/> </Typography.Link>
        
        
      </>}
      
      />
      <Divider />
      <Excel onFinish={handleOk} />
      </>
      ,
  }  
];

  return (
  <>
    
      <MyModal        
          title={""}
          visible={isVisible}
          onOk={handleOk}
          onCancel={handleCancel}
          maskClosable={false}
          footer={null}
          width={600}
        >
         <Tabs defaultActiveKey="1" items={items} />
           
      </MyModal>    
    </>
  );
};
export default New;